// Amplitude du tremblé d'écran (option feel, cosmétique) — math PURE, testable en Node (comme
// camera.ts / gestures.ts). L'ÉTAT (déclencheurs mort/bombe/tase, décroissance) vit dans render.ts ;
// ici, seulement le calcul d'amplitude bornée.

export const SHAKE_TICKS = 8 // durée de décroissance du tremblé (ticks)

/**
 * Amplitude du tremblé à l'instant `t`, décroissante depuis `amp` (au déclenchement) vers 0 à `end`,
 * et BORNÉE à [0, amp]. Le clamp est essentiel : quand le tick se réinitialise (respawn / niveau
 * suivant / nouvelle partie -> nouvel état à tick 0) alors que `end` est resté périmé (grand),
 * `(end - t)` devenait énorme -> sans clamp l'amplitude explosait à des centaines de px et TOUT
 * l'écran vibrait de façon excessive. Bornée, elle ne dépasse jamais `amp`.
 */
export function shakeAmplitudeAt(amp: number, end: number, t: number): number {
  return amp * Math.max(0, Math.min(1, (end - t) / SHAKE_TICKS))
}
